import { createFileRoute } from '@tanstack/react-router';
import { Subscriptions } from '../../components/Subscriptions';

export const Route = createFileRoute('/app/subscriptions')({
  component: SubscriptionsPage,
});

function SubscriptionsPage() {
  return <Subscriptions />;
}
